import styles from "../../ConversionAndPdpViewer.module.css";
import {
  buildComparisonSubtext,
  formatCurrency,
  formatCurrencyPrecise,
  formatNumber,
  formatPct,
} from "./formatters";
import { MetricCard, SummaryBanner, Waterfall, comparison } from "./ui";

export default function StoreFunnelTab({
  data,
  onGoToRankings,
  currency = "USD",
}) {
  const summary = data?.summary || {};
  const waterfall = data?.waterfall || {};
  const transitions = data?.transitions || [];
  const nextStep = data?.aiNextStep || data?.recommendedNextStep?.summary || "";
  const comparisonLabel = null;

  return (
    <div className={styles.sectionStack}>
      <SummaryBanner
        title="Funnel assessment"
        text={data?.aiAssessment || data?.assessment?.summary || ""}
        tone="warning"
      />

      <div className={styles.metricGrid4}>
        <MetricCard
          label="Orders"
          value={formatNumber(summary.orders)}
          subtext={comparisonLabel ? buildComparisonSubtext(summary.orders, summary.comparisonOrders) : null}
        />
        <MetricCard
          label="Revenue"
          value={formatCurrency(summary.revenue, currency)}
          subtext={comparisonLabel ? buildComparisonSubtext(summary.revenue, summary.comparisonRevenue, "currency", currency) : null}
        />
        <MetricCard
          label="AOV"
          value={formatCurrencyPrecise(summary.aov, currency)}
          subtext={comparisonLabel ? buildComparisonSubtext(summary.aov, summary.comparisonAov, "currencyPrecise", currency) : null}
        />
        <MetricCard
          label="Conv. rate"
          value={formatPct(summary.conversionRate)}
          subtext={comparisonLabel ? buildComparisonSubtext(summary.conversionRate, summary.comparisonConversionRate, "pct") : null}
        />
      </div>

      <Waterfall stages={waterfall?.stages || []} />

      {transitions.length > 0 && (
        <>
          <div className={styles.sectionHeading}>Transition detail</div>
          <div className={styles.tableWrap}>
            <table className={styles.table}>
              <thead>
                <tr>
                  <th>Transition</th>
                  <th className={styles.alignRight}>From</th>
                  <th className={styles.alignRight}>To</th>
                  <th className={styles.alignRight}>Rate</th>
                  {comparisonLabel ? <th className={styles.alignRight}>Compare Rate</th> : null}
                  <th className={styles.alignRight}>Lost</th>
                  <th>Assessment</th>
                </tr>
              </thead>
              <tbody>
                {transitions.map((row, index) => (
                  <tr key={row.key || index}>
                    <td>{row.label}</td>
                    <td className={styles.alignRight}>{row.from != null ? formatNumber(row.from) : "—"}</td>
                    <td className={styles.alignRight}>{row.to != null ? formatNumber(row.to) : "—"}</td>
                    <td className={styles.alignRight}>{row.rate != null ? formatPct(row.rate) : "—"}</td>
                    {comparisonLabel ? (
                      <td className={styles.alignRight}>
                        {row.comparisonRate != null ? `${formatPct(row.comparisonRate)}` : "—"}
                      </td>
                    ) : null}
                    <td className={styles.alignRight}>{row.lost != null ? formatNumber(row.lost) : "—"}</td>
                    <td>
                      {row.assessment ? (
                        <span className={comparison.getToneClass()[row.assessment.tone] || styles.neutral}>
                          {row.assessment.text}
                        </span>
                      ) : "—"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      <div className={styles.nextStepCard}>
        <div className={styles.nextStepTitle}>Where to go next</div>
        {nextStep ? <div className={styles.nextStepText}>{nextStep}</div> : null}
        <button
          type="button"
          className={styles.inlineLinkButton}
          onClick={onGoToRankings}
        >
          View PDP Rankings →
        </button>
      </div>
    </div>
  );
}
